import { Record } from "./fable_modules/fable-library.3.7.14/Types.js";
import { record_type, int32_type, uint8_type, class_type, uint32_type } from "./fable_modules/fable-library.3.7.14/Reflection.js";

export class Texture extends Record {
    constructor(Data, ClampedData, SourceCanvas, Width, Height) {
        super();
        this.Data = Data;
        this.ClampedData = ClampedData;
        this.SourceCanvas = SourceCanvas;
        this.Width = (Width | 0);
        this.Height = (Height | 0);
    }
}

export function Texture$reflection() {
    return record_type("App.PlatformModel.Texture", [], Texture, () => [["Data", class_type("Fable.Core.JS.TypedArray`1", [uint32_type])], ["ClampedData", class_type("Fable.Core.JS.TypedArray`1", [uint8_type])], ["SourceCanvas", class_type("Browser.Types.HTMLCanvasElement", void 0, HTMLCanvasElement)], ["Width", int32_type], ["Height", int32_type]]);
}

export function Texture__setPixel(this$, color, x, y) {
    const offset = ((y * this$.Width) + x) | 0;
    this$.Data[offset]=color;
}

export function Texture__getPixel(this$, x, y) {
    const offset = ((y * this$.Width) + x) | 0;
    return this$.Data[offset];
}

